import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type UserAgentWithId = {
  idUserAgent: number;
};

// Базовый тип для общих полей агента пользователя
type UserAgentCommonFields = {
  userAgentExchangePairs: unknown;
  userAgentSettings: unknown;
};

// Типы для WebSocket сообщений компонента userAgents
type UserAgentsListMessage = WebSocketMessageWithFields<'helper-agents', {
  userAgents: unknown[];
}>;
type UserAgentCreateMessage = WebSocketMessageWithFields<'helper-agent-create' | 'helper-agent-create-success', UserAgentWithId & {
  idUserAccount: number;
  idAgent: number;
} & UserAgentCommonFields>;
type UserAgentUpdateMessage = WebSocketMessageWithFields<'helper-agent-update' | 'helper-agent-update-success', UserAgentWithId & UserAgentCommonFields>;
type UserAgentDeleteMessage = WebSocketMessageWithFields<'helper-agent-delete' | 'helper-agent-delete-success', UserAgentWithId>;
type UserAgentLockMessage = WebSocketMessageWithFields<'helper-agent-lock' | 'helper-agent-lock-success', UserAgentWithId>;
type UserAgentUnlockMessage = WebSocketMessageWithFields<'helper-agent-unlock' | 'helper-agent-unlock-success', UserAgentWithId>;

// Объединенный тип для всех сообщений
type UserAgentsWebSocketMessage = 
  | UserAgentsListMessage 
  | UserAgentCreateMessage 
  | UserAgentUpdateMessage 
  | UserAgentDeleteMessage 
  | UserAgentLockMessage 
  | UserAgentUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataUserAgents',
},
  __name: 'userAgents',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID агента пользователя
const handleWebSocketMessage = (data: UserAgentsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'helper-agents':
      store.dispatch('userAgent/wsSetUserAgents', {
        userAgents: data.userAgents,
      });
      break;

    case 'helper-agent-create':
    case 'helper-agent-create-success':
      store.dispatch('userAgent/wsUserAgentCreate', {
        idUserAgent: data.idUserAgent,
        idUserAccount: data.idUserAccount,
        idAgent: data.idAgent,
        userAgentExchangePairs: data.userAgentExchangePairs,
        userAgentSettings: data.userAgentSettings,
      });
      break;

    case 'helper-agent-update':
    case 'helper-agent-update-success':
      store.dispatch('userAgent/wsUserAgentUpdate', {
        idUserAgent: data.idUserAgent,
        userAgentExchangePairs: data.userAgentExchangePairs,
        userAgentSettings: data.userAgentSettings,
      });
      break;

    case 'helper-agent-delete':
    case 'helper-agent-delete-success':
      store.dispatch('userAgent/wsUserAgentDelete', {
        idUserAgent: data.idUserAgent,
      });
      break;

    case 'helper-agent-lock':
    case 'helper-agent-lock-success':
      store.dispatch('userAgent/wsUserAgentLock', {
        idUserAgent: data.idUserAgent,
      });
      break;

    case 'helper-agent-unlock':
    case 'helper-agent-unlock-success':
      store.dispatch('userAgent/wsUserAgentUnlock', {
        idUserAgent: data.idUserAgent,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})